<template>
  <v-card dark>
    <v-toolbar dense :color="color">
      <v-toolbar-title class="font-weight-light">Usuario</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <div class="text-xs-center">
        <h2 class="font-weight-light">{{item.email}}</h2>
        <span>{{rol}}</span>
        <br />
        <span class="main" v-if="item.is_admin">Administrador</span>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    item: {
      type: Object,
      required: true
    },
    roles: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    rol () {
      return this.roles.find(sel => sel.id === this.item.rol_id).text || null
    }
  }
}
</script>
<style scoped>
h2 {
  font-size: 25px;
}
.main {
  background-color: #fff;
  color: #000;
  padding:0 7px;
  border-radius: 25px;
  margin-right: 5px;
  font-size:11px;
}
</style>